import { render, staticRenderFns } from "./paper-upload-in-folder.html?vue&type=template&id=4d226800&scoped=true&external"
import script from "./paper-upload-in-folder.js?vue&type=script&lang=js&external"
export * from "./paper-upload-in-folder.js?vue&type=script&lang=js&external"
import style0 from "./paper-upload-in-folder.scss?vue&type=style&index=0&id=4d226800&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d226800",
  null
  
)

export default component.exports